(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp.validacao', [
      'mgpCorregedoriaApp.core'
    ]);
})();
